import BarberOverview from "./barberOverview";
import SmsCreditPage from "./smsCredit";
import DashboardLayout from "@/layout/dashboard";
import DashboardAccess from "@/utilities/helper/protectedRoute/DashboardAccess";
import FullLayout from "@/layout/fullLayout";
import { ProtectedRoute } from "@/utilities/helper/protectedRoute";
import { Outlet, RouteObject } from "react-router-dom";
import Customers from "./customer";
import AddCustomer from "./customer/add";
import CustomerDetails from "./customer/details";
import SearchCustomerPage from "./customer/search";
import { Discount } from "./discount";
import DiscountAmount from "./discount/amountDiscount";
import CreateDiscountMessage from "./discount/create/createDiscountMessage";
import EditDiscountMessage from "./discount/editMessage/editDiscountMessage";
import DiscountFactor from "./discount/factor";
import DiscountPercentage from "./discount/percentageDiscount";
import SelectDateTime from "./discount/selectDateTime";
import SelectDiscountType from "./discount/selectDiscountType";
import { DiscountSelectGroup } from "./discount/selectGroup";
import DiscountSelectMessage from "./discount/selectMessage/discountSelectMessage";
import Factor from "./factor";
import Messages from "./messages";
import ExitTemplate from "./messages/editTemplate";
import MessageFactor from "./messages/factor";
import SelectTemplate from "./messages/selectTemplate";
import SelectedUser from "./messages/selectUsers";
import ProfileHome from "./profile";
import AutoMessage from "./profile/autoMessage";
import ChangeMessage from "./profile/autoMessage/changeMessage";
import SelectAutoMessageTemplate from "./profile/autoMessage/selectTemplate";
import SelectAutoMessageTime from "./profile/autoMessage/selectTime";
import CustomerGroups from "./profile/customerGroup";
import AddCustomerGroup from "./profile/customerGroup/add";
import CustomerGroupsMembers from "./profile/customerGroup/members";
import EditProfile from "./profile/edit";
import EditProfileAddress from "./profile/edit/address";
import EditInformationProfile from "./profile/edit/information";
import EditMerchantProfile from "./profile/edit/merchant";
import EditSeo from "./profile/edit/seo";
import EditProfileSocialMedia from "./profile/edit/socialMedia";
import ImportContact from "./profile/importContact";
import Notifications from "./profile/notifications";
import ReferralCode from "./profile/referral";
import ServicePrice from "./profile/servicePrice";
import Templates from "./profile/template";
import AddTemplate from "./profile/template/add";
import EditTemplate from "./profile/template/edit";
import Transactions from "./profile/transactions";
import VerificationMerchant from "./profile/verification";
import VerificationNationalID from "./profile/verification/nationalCodeImage";
import VerificationResult from "./profile/verification/result";
import Schedule from "./schedule";
import AddScheduleServices from "./schedule/addService";
import SaveAppointment from "./schedule/saveAppointment";
import SelectCustomer from "./schedule/selectCustomer";
import SelectService from "./schedule/selectService";
import SelectTime from "./schedule/selectTime";
import ScheduleServices from "./schedule/services";
import SendAreaMessage from "./sendAreaMessage";
import AreaMessageFactor from "./sendAreaMessage/factor";
import SelectArea from "./sendAreaMessage/selectArea";
import SelectAreaInformation from "./sendAreaMessage/selectInformation";
import SelectAreaTemplate from "./sendAreaMessage/selectTemplate";
import Setting from "./setting";

import Calendar from "./calendar";
import EditCustomer from "./customer/edit";
import MessageDashboard from "./dashboardMessage";
import Marketing from "./marketing";
import EditProfileGallery from "./profile/edit/gallery";
import WorkingHours from "./profile/edit/workHours";
import SiteTemplate from "./profile/edit/siteTemplate";
import SiteQrCode from "./profile/edit/siteQrCode";
import TermsAndCondition from "./profile/termsAndCondition";
import AddCategoryService from "./schedule/addCategoryService";
import EditCategoryService from "./schedule/editCategoryService";
import EditScheduleServices from "./schedule/editService";
import Teams from "./teams";
import ShiftsSchedule from "./teams/shiftsSchedule";
import TeamMembers from "./teams/teamMembers";
import AddTeamMember from "./teams/teamMembers/add";
import TeamMemberDetail from "./teams/teamMembers/detail";
import EditTeamMember from "./teams/teamMembers/edit";
import EditTeamMemberServices from "./teams/teamMembers/services";
import AppointmentDeposit from "./report/appointmentDeposit";
import Payments from "./payment";
import AddPayment from "./payment/add";
import Invoices from "./invoices";
import FinancePage from "./finance";
import PadixSettlements from "./padixSettlements";
import SubscriptionPage from "./subscription";
import SubscriptionResult from "./subscription/Result";
import SalonReviews from "./reviews";
import EmployeeSettlements from "./settlements/employees";
import DashboardOverviewPage from "./overview";
import DashboardLanding from "./dashboardLanding";
import MenuPage from "./menu";

export const DashboardRoutes: RouteObject[] = [
  {
    path: "dashboard",
    element: (
      <ProtectedRoute>
        <DashboardAccess><DashboardLayout /></DashboardAccess>
      </ProtectedRoute>
    ),
    errorElement: <>error page</>,
    children: [
      { path: "barber-overview", element: <BarberOverview /> },
      { path: "reviews", element: <SalonReviews /> },
      { path: "sms-credit", element: <SmsCreditPage /> },
      { path: "menu", element: <MenuPage /> },
      // SMS home and history keep the bottom menu; the send steps (below, FullLayout) are a focused task without it.
      { path: "sendMessage", element: <MessageDashboard /> },
      { path: "messages", element: <Messages /> },
      {
        index: true,
        element: <DashboardLanding />,
      },
      {
        path: "overview",
        element: <DashboardOverviewPage />,
      },
      {
        path: "customers",
        element: <Customers />,
      },
      {
        path: "appointmentDeposit",
        element: <AppointmentDeposit />,
      },
      {
        path: "invoices",
        element: <Invoices />,
      },
      { path: "finance/:tab?", element: <FinancePage /> },
      { path: "padix-settlements", element: <PadixSettlements /> },
      { path: "subscription", element: <SubscriptionPage /> },
      { path: "subscription/result/:id", element: <SubscriptionResult /> },
      {
        path: "settlements/employees",
        element: <EmployeeSettlements />,
      },
      {
        path: "customers/details/:id",
        element: <CustomerDetails />,
      },
      {
        path: "calendar/:cId?",
        element: <Calendar />,
      },
      {
        path: "teams",
        element: <Teams />,
      },
      {
        path: "teams/teamMembers",
        element: <TeamMembers />,
      },
      {
        path: "teams/shiftsSchedule",
        element: <ShiftsSchedule />,
      },

      {
        path: "schedule/services",
        element: <ScheduleServices />,
      },

      {
        path: "marketing",
        element: <Marketing />,
      },
      {
        path: "payments",
        element: <Payments />,
      },

      {
        path: "profile",
        element: <Outlet />,
        children: [
          { path: "autoMessage", element: <AutoMessage /> },
          { path: "edit", element: <EditProfile /> },
          { path: "edit/information", element: <EditInformationProfile /> },
          {
            path: "edit/merchantProfile",
            element: <EditMerchantProfile />,
          },
          {
            path: "edit/merchantAddress",
            element: <EditProfileAddress />,
          },
          {
            path: "edit/socialMedia",
            element: <EditProfileSocialMedia />,
          },
          { path: "edit/seo", element: <EditSeo /> },
          {
            path: "edit/gallery",
            element: <EditProfileGallery />,
          },
          {
            path: "edit/workHours",
            element: <WorkingHours />,
          },
          {
            path: "edit/siteTemplate",
            element: <SiteTemplate />,
          },
          {
            path: "edit/siteQrCode",
            element: <SiteQrCode />,
          },
          { path: "importContact", element: <ImportContact /> },
        ],
      },
    ],
  },
];

export const FullLayoutRoutes: RouteObject[] = [
  {
    path: "dashboard",
    element: <ProtectedRoute><DashboardAccess><FullLayout /></DashboardAccess></ProtectedRoute>,
    errorElement: <>error page</>,
    children: [
      {
        path: "customers/add",
        element: <AddCustomer />,
      },
      {
        path: "customers/search",
        element: <SearchCustomerPage />,
      },

      {
        path: "customers/edit/:id",
        element: <EditCustomer />,
      },
    ],
  },
];

export const FullLayoutRoutesAnimateFromRight: RouteObject[] = [
  {
    path: "dashboard",
    element: <ProtectedRoute><DashboardAccess><FullLayout /></DashboardAccess></ProtectedRoute>,
    errorElement: <>error page</>,
    children: [
      {
        path: "teams/teamMembers/add",
        element: <AddTeamMember />,
      },
      {
        path: "teams/teamMembers/detail/:id",
        element: <TeamMemberDetail />,
      },
      {
        path: "teams/teamMembers/edit/:id",
        element: <EditTeamMember />,
      },
      {
        path: "teams/teamMembers/editServices/:id",
        element: <EditTeamMemberServices />,
      },
      {
        path: "messages/selectTemplate",
        element: <SelectTemplate />,
      },
      {
        path: "messages/editTemplate",
        element: <ExitTemplate />,
      },
      {
        path: "messages/selectUser/:id?",
        element: <SelectedUser />,
      },
      {
        path: "messages/factor",
        element: <MessageFactor />,
      },

      {
        path: "areaMessage",
        element: <SendAreaMessage />,
      },
      {
        path: "areaMessage/selectArea",
        element: <SelectArea />,
      },
      {
        path: "areaMessage/selectAreaTemplate",
        element: <SelectAreaTemplate />,
      },
      {
        path: "areaMessage/selectInformation",
        element: <SelectAreaInformation />,
      },
      {
        path: "areaMessage/areaMessageFactor",
        element: <AreaMessageFactor />,
      },

      {
        path: "discount",
        element: <Discount />,
      },
      {
        path: "discount/selectGroup",
        element: <DiscountSelectGroup />,
      },
      {
        path: "discount/selectMessage",
        element: <DiscountSelectMessage />,
      },
      {
        path: "discount/selectDiscountType",
        element: <SelectDiscountType />,
      },
      {
        path: "discount/discountAmount",
        element: <DiscountAmount />,
      },
      {
        path: "discount/discountPercentage",
        element: <DiscountPercentage />,
      },
      {
        path: "discount/selectDateTime",
        element: <SelectDateTime />,
      },
      {
        path: "discount/discountFactor/:id?",
        element: <DiscountFactor />,
      },
      {
        path: "discount/editMessage",
        element: <EditDiscountMessage />,
      },
      {
        path: "discount/create",
        element: <CreateDiscountMessage />,
      },

      {
        path: "factor/:id",
        element: <Factor />,
      },
      {
        path: "schedule",
        element: <Schedule />,
      },
      {
        path: "schedule/add",
        element: <SelectCustomer />,
      },
      {
        path: "schedule/selectService",
        element: <SelectService />,
      },
      {
        path: "schedule/selectTime",
        element: <SelectTime />,
      },

      {
        path: "schedule/save",
        element: <SaveAppointment />,
      },
      {
        path: "schedule/services",
        element: <ScheduleServices />,
      },
      {
        path: "schedule/services/add/:isNew?",
        element: <AddScheduleServices />,
      },
      {
        path: "schedule/services/editService",
        element: <EditScheduleServices />,
      },
      {
        path: "schedule/services/addCategoryService",
        element: <AddCategoryService />,
      },
      {
        path: "schedule/services/editCategoryService",
        element: <EditCategoryService />,
      },
      {
        path: "setting",
        element: <Setting />,
      },
      {
        path: "payments/add/:appId?",
        element: <AddPayment />,
      },
      {
        path: "profile",
        element: <Outlet />,
        children: [
          { index: true, element: <ProfileHome /> },
          { path: "edit", element: <EditProfile /> },
          { path: "edit/information", element: <EditInformationProfile /> },
          {
            path: "edit/merchantProfile",
            element: <EditMerchantProfile />,
          },
          {
            path: "edit/merchantAddress",
            element: <EditProfileAddress />,
          },
          {
            path: "edit/socialMedia",
            element: <EditProfileSocialMedia />,
          },
          { path: "edit/seo", element: <EditSeo /> },
          { path: "customerGroup", element: <CustomerGroups /> },
          { path: "customerGroup/add", element: <AddCustomerGroup /> },
          {
            path: "customerGroup/members",
            element: <CustomerGroupsMembers />,
          },
          { path: "transaction", element: <Transactions /> },

          { path: "referralCode", element: <ReferralCode /> },
          { path: "autoMessage", element: <AutoMessage /> },
          {
            path: "autoMessage/selectTemplate",
            element: <SelectAutoMessageTemplate />,
          },
          {
            path: "autoMessage/selectTime",
            element: <SelectAutoMessageTime />,
          },
          { path: "autoMessage/changeMessage", element: <ChangeMessage /> },
          { path: "template", element: <Templates /> },
          { path: "template/add", element: <AddTemplate /> },
          { path: "template/edit", element: <EditTemplate /> },
          { path: "servicePrice", element: <ServicePrice /> },
          { path: "termsAndCondition", element: <TermsAndCondition /> },
          { path: "notifications", element: <Notifications /> },
          { path: "verification", element: <VerificationMerchant /> },
          { path: "verification/IDImage", element: <VerificationNationalID /> },
          { path: "verification/result", element: <VerificationResult /> },
        ],
      },
    ],
  },
];
